import { render, staticRenderFns } from "./zhsysManagePlatform.vue?vue&type=template&id=a93d19b8&scoped=true&"
import script from "./zhsysManagePlatform.vue?vue&type=script&lang=js&"
export * from "./zhsysManagePlatform.vue?vue&type=script&lang=js&"
import style0 from "./zhsysManagePlatform.vue?vue&type=style&index=0&id=a93d19b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93d19b8",
  null
  
)

export default component.exports